const getURLSearchParams = (params: string) => new URLSearchParams(params);

export const urlParam = (param: string, urlParameterString: string) => {
    let params = getURLSearchParams(urlParameterString);

    return params.get(param);
};
